import { Button, Card, Typography, Divider, Form, Switch, Tooltip } from "antd";
import { Input } from "antd";
import { LeftOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import * as Validation from "../../../utils/helper/validation";
import toast from "react-hot-toast";
import { changeLoader } from "../../../redux/reducers/loader";
import * as Apis from "../../../utils/helper/enum";
import globalRequest from "../../../utils/global/globalRequest";
import { jwtDecode } from "jwt-decode";
import {
  addDeleteGetLocalStorage,
  storageKeys,
} from "../../../utils/global/localData";
import { checkPermissionAction } from "../../../utils/helper/utils";

const AddPackagingType = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [checked, setChecked] = useState(false);
  let { id } = useParams();
  useEffect(() => {
    const userAccess = addDeleteGetLocalStorage(
      storageKeys?.USER_TOKEN,
      {},
      "get"
    );
    let permissionJson = [];
    if (userAccess) {
      const decoded = jwtDecode(userAccess);
      permissionJson = decoded?.user?.rolePermission?.permissionJson;
    }
    if (id) {
      if (!checkPermissionAction("Packaging Type", permissionJson, "edit")) {
        navigate("/manage-packaging-type");
      }
    } else {
      if (!checkPermissionAction("Packaging Type", permissionJson, "add")) {
        navigate("/manage-packaging-type");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleInputChange = (name) => {
    form.setFields([
      {
        name,
        errors: [],
      },
    ]);
  };

  const handleSubmit = async (values) => {
    if (values.status === true) values.status = "active";
    if (values.status === false) values.status = "inactive";
    try {
      let url = Apis?.MANAGE_PACKAGING_TYPE?.CREATE;
      let method = "post";
      if (id) {
        url = Apis?.MANAGE_PACKAGING_TYPE?.EDIT + "/" + id;
        method = "put";
      }
      values.locales = [
        { languageCode: "en", name: values?.name?.en },
        { languageCode: "ar", name: values?.name?.ar },
      ];
      let response = await globalRequest(url, method, values, {}, true);
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let msg = "Packaging type created successfully";
        if (id) msg = "Packaging type updated successfully";
        toast.success(msg, {
          duration: 2000,
        });
        navigate("/manage-packaging-type");
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  };
  const getPackagingTypeDetail = async (id) => {
    try {
      let response = await globalRequest(
        Apis.MANAGE_PACKAGING_TYPE.GET_DETAIL + "/" + id,
        "get",
        {},
        {},
        true
      );
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let data = apiResponse?.data;

        const enLocale = data?.locales?.find(l => l.languageCode === "en");
        const arLocale = data?.locales?.find(l => l.languageCode === "ar");
        form.setFieldValue(["name", "en"], enLocale?.name || "");
        form.setFieldValue(["name", "ar"], arLocale?.name || "");
        form.setFieldValue("status", data?.status === "active" ? true : false);
        form.setFieldValue("length", `${data?.length}`);
        form.setFieldValue("width", `${data?.width}`);
        form.setFieldValue("height", `${data?.height}`);
        setChecked(data?.status === "active" ? true : false);
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
  };
  useEffect(() => {
    if (id) getPackagingTypeDetail(id);
    else {
      form.setFieldValue("status", true);
      setChecked(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      <Card>
        <Typography className="text-xl font-semibold" align={"left"}>
          <LeftOutlined className="mr-2" onClick={() => navigate(-1)} />
          {id ? "Edit" : "Add"} Packaging Type
        </Typography>
        <Divider />
        <div className="min-h-[calc(100vh_-_305px)]">
          <Form
            layout="vertical"
            form={form}
            onFinish={handleSubmit}
            style={{
              maxWidth: 600,
              width: "100%",
            }}
            initialValues={{
              remember: true,
            }}
            autoComplete="off"
          >
            <Form.Item
              label="Name (English)"
              name={["name", "en"]}
              rules={[
                {
                  required: true,
                  message: "Please enter packaging name in English.",
                },
                {
                  max: 80,
                  message: "Please enter max 80 character.",
                },
              ]}
            >
              <Input size="large" placeholder="Enter name in English" />
            </Form.Item>

            <Form.Item
              label="Name (Arabic)"
              name={["name", "ar"]}
              rules={[
                {
                  required: true,
                  message: "Please enter packaging name in Arabic.",
                },
                {
                  max: 80,
                  message: "Please enter max 80 character.",
                },
              ]}
            >
              <Input size="large" placeholder="Enter name in Arabic" />
            </Form.Item>
            <Form.Item
              label="Status"
              name="status"              
              rules={[
                {
                  required: true,
                  message: "Please select status.",
                },
              ]}
            >
              <Switch
                checkedChildren="active"
                unCheckedChildren="inactive"
                checked={checked}
                onChange={(value) => {
                  setChecked(value);
                  form.setFieldValue("status", value);
                  handleInputChange("status");
                }}
              />{" "}
              <Tooltip title="This will allow the admin to assign it to a driver if enabled">
                <InfoCircleOutlined className="ml-4" />
              </Tooltip>
            </Form.Item>
            <Form.Item
              label="Length"
              name="length"
              rules={[
                {
                  required: true,
                  message: "Please enter length.",
                },
                {
                  max: 6,
                  message: "Please enter max 6 digit include decimal.",
                },
              ]}
            >
              <Input
                size="large"
                suffix="CM"
                onChange={(e) => {
                  let value = Validation.strFormat(
                    e.target.value,
                    "float|min-value:0.1"
                  );
                  form.setFieldValue("length", value.trimStart());
                  handleInputChange("length");
                }}
              />
            </Form.Item>
            <Form.Item
              label="Width"
              name="width"
              rules={[
                {
                  required: true,
                  message: "Please enter width.",
                },
                {
                  max: 6,
                  message: "Please enter max 6 digit include decimal.",
                },
              ]}
            >
              <Input
                size="large"
                suffix="CM"
                onChange={(e) => {
                  let value = Validation.strFormat(
                    e.target.value,
                    "float|min-value:0.1"
                  );
                  form.setFieldValue("width", value.trimStart());
                  handleInputChange("width");
                }}
              />
            </Form.Item>
            <Form.Item
              label="Height"
              name="height"
              rules={[
                {
                  required: true,
                  message: "Please enter height.",
                },
                {
                  max: 6,
                  message: "Please enter max 6 digit include decimal.",
                },
              ]}
            >
              <Input
                size="large"
                suffix="CM"
                onChange={(e) => {
                  let value = Validation.strFormat(
                    e.target.value,
                    "float|min-value:0.1"
                  );
                  form.setFieldValue("height", value.trimStart());
                  handleInputChange("height");
                }}
              />
            </Form.Item>
          </Form>
        </div>
        <Divider />
        <div className="flex justify-end gap-3">
          <Button onClick={() => navigate("/manage-packaging-type")}>
            Cancel
          </Button>
          <Button
            type="primary"
            htmlType="submit"
            onClick={() => form.submit()}
          >
            Save
          </Button>
        </div>
      </Card>
    </>
  );
};
export default AddPackagingType;
